import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
} from 'react-share';

import Align from '@marvelapp/marvel-ui/align';
import { InlineGrid } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';
import { HOST } from 'marketing-website/configs/urls';
import generalStyles from './style/general.module.css';

function SocialBlock({ description, location, title }) {
  const url = `${HOST}${location.pathname}`;
  return (
    <Spacing size="xl" position="topBottom" type="margin">
      <PageWrap>
        <Align type="center">
          <InlineGrid alignContent="middle">
            <div className={generalStyles.border} />
            <div className={generalStyles.hover}>
              <FacebookShareButton quote={title} url={url}>
                <FacebookIcon round size={40} />
              </FacebookShareButton>
            </div>
            <div className={generalStyles.hover}>
              <LinkedinShareButton
                title={title}
                description={description}
                url={url}
              >
                <LinkedinIcon round size={40} />
              </LinkedinShareButton>
            </div>
            <div className={generalStyles.hover}>
              <TwitterShareButton title={title} url={url}>
                <TwitterIcon round size={40} />
              </TwitterShareButton>
            </div>
            <div className={generalStyles.border} />
          </InlineGrid>
        </Align>
      </PageWrap>
    </Spacing>
  );
}

export default withRouter(SocialBlock);

SocialBlock.propTypes = {
  location: PropTypes.object.isRequired,
  description: PropTypes.string,
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/modules/ContentBlocks/Social/index.js